import compact from "lodash/compact";
import { useSubtemplateDefaultValues } from "PFApp/hooks/activity_form/use_subtemplate_default_values";
import { FormFieldData } from "PFApp/types/activity_form/activity_form_schema";
import { useSubtemplatesDefaultAPICustomValues } from "PFCore/hooks/queries/subtemplates/use_subtemplates_default_api_custom_values";
import { Subtemplate } from "PFTypes";
import { useEffect } from "react";

import { useActivityFormStore } from "../activity_form_store";
import { useFieldsAutoPopulation } from "./use_fields_auto_population";

type UseDynamicSubtemplateFields = {
  subtemplate: Subtemplate | null;
  enabled: boolean;
};

export const useDynamicSubtemplateFields = ({ subtemplate, enabled }: UseDynamicSubtemplateFields) => {
  const activityCreator = useActivityFormStore((state) => state.activityCreator);
  const template = useActivityFormStore((state) => state.template);
  const { populateFromAllSources } = useFieldsAutoPopulation();

  const subtemplateKey = subtemplate?.subtemplate_key;
  const { getSubtemplateDefaultValues } = useSubtemplateDefaultValues();
  const { getAPICustomValuesByText, isFetched } = useSubtemplatesDefaultAPICustomValues({
    templateKey: template.key
  });

  useEffect(() => {
    if (!enabled || !subtemplate) {
      return;
    }

    const dataToPopulate: FormFieldData[] = [];

    const { metadataFields, customFields } = getSubtemplateDefaultValues({
      subtemplate,
      activityCreator
    });

    const customFieldsWithApiValues = compact(
      customFields.map(({ fieldName, values }) => ({
        fieldName,
        values: getAPICustomValuesByText(fieldName, values)
      }))
    ) as FormFieldData[];

    dataToPopulate.push(...metadataFields, ...customFieldsWithApiValues);

    populateFromAllSources({ sourceValues: dataToPopulate, source: "subtemplate" });
  }, [subtemplateKey, enabled]);

  return { isLoading: !isFetched };
};
